import React from 'react'
import { useTranslation } from '../../hooks/use-i18n'
import authService from '../../services/authService'

type GoogleSignInButtonProps = {
  mode: 'sign-in' | 'sign-up'
}

const GoogleIcon = () => (
  <svg width="20" height="20" viewBox="0 0 48 48" aria-hidden="true">
    <path fill="#FFC107" d="M43.611 20.083H42V20H24v8h11.303C33.654 32.657 29.083 36 24 36c-5.514 0-10-4.486-10-10s4.486-10 10-10c2.511 0 4.817.926 6.548 2.474l5.657-5.657C34.046 9.053 29.268 7 24 7 12.955 7 4 15.955 4 27s8.955 20 20 20 20-8.955 20-20c0-1.341-.138-2.65-.389-3.917z" />
    <path fill="#FF3D00" d="M6.306 14.691l6.571 4.819C14.655 16.108 18.961 13 24 13c2.511 0 4.817.926 6.548 2.474l5.657-5.657C34.046 9.053 29.268 7 24 7 16.318 7 9.656 11.337 6.306 14.691z" />
    <path fill="#4CAF50" d="M24 47c5.166 0 9.86-1.977 13.409-5.192l-6.19-5.238C29.211 38.091 26.715 39 24 39c-5.077 0-9.402-3.223-10.956-7.743l-6.62 5.096C9.557 42.088 16.227 47 24 47z" />
    <path fill="#1976D2" d="M43.611 20.083H42V20H24v8h11.303a12.04 12.04 0 0 1-4.087 5.571l.003-.002 6.19 5.238C36.971 39.205 44 34 44 24c0-1.341-.138-2.65-.389-3.917z" />
  </svg>
)

export function AuthOrDivider() {
  const { t } = useTranslation()
  return (
    <div className="flex items-center gap-3 my-5">
      <div className="flex-1 h-px bg-border" />
      <span className="text-small text-foreground/70">{t('auth.orContinueWith')}</span>
      <div className="flex-1 h-px bg-border" />
    </div>
  )
}

const GoogleSignInButton: React.FC<GoogleSignInButtonProps> = ({ mode }) => {
  const { t } = useTranslation()

  return (
    <button
      type="button"
      onClick={() => authService.startGoogleSignIn()}
      className="w-full flex items-center justify-center gap-3 py-2.5 sm:py-3 rounded-lg sm:rounded-xl border border-border bg-muted/10 text-foreground font-semibold text-small sm:text-nav hover:bg-muted/20 transition-all"
    >
      <GoogleIcon />
      {mode === 'sign-up' ? t('auth.signUpWithGoogle') : t('auth.signInWithGoogle')}
    </button>
  )
}

export function AuthGoogleSection({ mode }: GoogleSignInButtonProps) {
  return (
    <>
      <AuthOrDivider />
      <GoogleSignInButton mode={mode} />
    </>
  )
}

export default GoogleSignInButton
